import { AlfaKodeOversiktResponse } from '../../models/NV06AlfaOversikt';
import * as actionTypesNV06 from '../actions/actionTypesNV06';
import * as fromApp from '../rootReducer';

export interface FeatureState extends fromApp.AppState {
  state: NV06State;
}

export interface NV06State {
  data: AlfaKodeOversiktResponse | null;
  error: any;
  isFetching: boolean;
}

const initialState: NV06State = {
  data: null,
  error: undefined,
  isFetching: false,
};

const NV06Reducer = (state = initialState, action: any): NV06State => {
  switch (action.type) {
    case actionTypesNV06.NV06_ALFA_OVERSIKT_GET:
      return {
        ...state,
        isFetching: true,
        error: undefined,
      };
    case actionTypesNV06.NV06_ALFA_OVERSIKT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isFetching: false,
        error: undefined,
      };
    case actionTypesNV06.NV06_ALFA_OVERSIKT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    case actionTypesNV06.NV06_RESET:
      return initialState;
    default:
      return state;
  }
};

export default NV06Reducer;
